/* LodyFair zoeken. Horizon-port 10 oktober 2026 (winkelbouwer): gedrag gelijk aan live, plus
   ontwerpbord 15 in tekenResultaten (collecties eerst, op aanvraag via WhatsApp bij 0 resultaten).

   Twee dingen, één bestand:

   1. DESKTOP — alleen de LEGE STAAT. De live suggesties bestaan al en zitten in
      assets/lodyfair-desktop-header.js; die laten we met rust. Zodra je in het
      veld klikt zonder te typen, vullen we hetzelfde paneel met populaire
      zoekopdrachten en bestsellers. Ga je typen, dan neemt het andere script het
      over en verdwijnt de lege staat vanzelf.

   2. MOBIEL — het volledige scherm. Dit vervangt de zoeklade van Impulse: we
      onderscheppen de klik op .js-search-header en openen ons eigen paneel.

   Beide gebruiken dezelfde <template> met de lege staat, zodat de lijst maar op
   één plek bestaat. */
(function () {
  var WACHT = 250;   // ms nadat het typen stopt
  var MINIMUM = 2;   // vanaf hoeveel tekens we zoeken

  var sjabloon = document.querySelector('[data-lf-zk-leeg]');
  var overlay = document.querySelector('[data-lf-zk]');
  var waas = document.querySelector('[data-lf-zk-waas]');
  if (!sjabloon) return;

  var wortel = document.documentElement;

  function legeStaat() {
    return sjabloon.content.cloneNode(true);
  }

  function geld(bedrag) {
    var n = parseFloat(bedrag);
    if (isNaN(n)) return '';
    var c = Math.round(n * 100), heel = Math.floor(c / 100), rest = c % 100;
    return '€' + String(heel).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (rest < 10 ? '0' + rest : rest);
  }

  function veilig(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- gedeeld: resultaten opvragen en tekenen ---------- */

  function zoekOp(term, klaar) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var res = (d && d.resources && d.resources.results) || {};
        klaar(res.products || [], res.collections || []);
      })
      .catch(function () { klaar([], []); });
  }

  /* HORIZON / ontwerpbord 15 (10 okt 2026): collecties eerst, dan producten (uitverkocht achteraan,
     zie zoekOp), streepprijs en een groene "1–2 werkdagen" bij de tag snelle-levering. Niets
     gevonden: eerst het op-aanvraag-blok (WhatsApp 06 58993634), dan de populaire zoekopdrachten. */
  function tekenResultaten(doel, producten, collecties, term, teksten) {
    if (!producten.length && !collecties.length) {
      doel.innerHTML = '<p class="lf-zk__leegmelding">' +
        teksten.niets.replace('__TERM__', veilig(term)) + '</p>' +
        '<div class="lf-zk__aanvraag">' +
          '<p class="lf-zk__aanvraag-kop">' + veilig(teksten.aanvraagKop) + '</p>' +
          '<p class="lf-zk__aanvraag-tekst">' + veilig(teksten.aanvraagTekst) + '</p>' +
          '<a class="lf-zk__aanvraag-knop" rel="nofollow" href="https://wa.me/31658993634?text=' +
            encodeURIComponent(teksten.aanvraagBericht.replace('__TERM__', term)) + '">WhatsApp 06 58993634</a>' +
        '</div>';
      doel.appendChild(legeStaat());
      return;
    }

    var html = '';

    /* Ontwerpbord 15 (11 okt 2026): eyebrow "Collecties" met rijen, dan "Producten" met foto 56×72,
       titel, levertijdregel en prijs rechts; zwarte knop "Alle resultaten". */
    if (collecties.length) {
      html += '<div class="lf-zk__groep"><p class="lf-zk__kop">' + veilig(teksten.collecties) + '</p>';
      collecties.forEach(function (c) {
        html += '<a class="lf-zk__col" href="' + veilig(c.url) + '"><span>' + veilig(c.title) + '</span></a>';
      });
      html += '</div>';
    }

    if (producten.length) {
      html += '<div class="lf-zk__groep"><p class="lf-zk__kop">' + veilig(teksten.producten) + '</p>';
      producten.forEach(function (p) {
        var foto = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        if (foto) foto += (foto.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        var snel = tags.indexOf('snelle-levering') > -1;
        var streep = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
        var lev = p.available === false ? veilig(teksten.uit)
          : (snel ? '<span class="lf-zk__stip is-snel"></span>' + veilig(teksten.snel) : '<span class="lf-zk__stip"></span>' + veilig(teksten.normaal || '7–10 werkdagen'));
        html += '<a class="lf-zk__rij' + (p.available === false ? ' is-uit' : '') + '" href="' + veilig(p.url) + '">' +
          '<span class="lf-zk__foto">' + (foto ? '<img src="' + veilig(foto) + '" alt="" loading="lazy" width="56" height="72">' : '') + '</span>' +
          '<span class="lf-zk__info"><span class="lf-zk__titel">' + veilig(p.title) + '</span>' +
            '<span class="lf-zk__lev">' + lev + '</span></span>' +
          '<span class="lf-zk__prijs">' + geld(p.price) + (streep ? ' <s>' + geld(p.compare_at_price_max) + '</s>' : '') + '</span>' +
        '</a>';
      });
      html += '<a class="lf-zk__alles" href="/search?q=' + encodeURIComponent(term) + '&type=product">' +
        teksten.alles.replace('__TERM__', veilig(term)) + '</a></div>';
    } else {
      html += '<a class="lf-zk__alles" href="/search?q=' + encodeURIComponent(term) + '&type=product">' +
        teksten.alles.replace('__TERM__', veilig(term)) + '</a>';
    }

    doel.innerHTML = html;
  }

  /* ---------- 1. desktop: lege staat in het bestaande paneel ---------- */

  (function desktop() {
    var invoer = document.querySelector('[data-lf-dh-zoek]');
    var paneel = document.querySelector('[data-lf-dh-suggesties]');
    if (!invoer || !paneel) return;

    function toonLeeg() {
      paneel.innerHTML = '';
      paneel.appendChild(legeStaat());
      paneel.classList.add('is-leeg');
      paneel.hidden = false;
      wortel.classList.add('lf-zk-open');
    }

    function verberg() {
      paneel.classList.remove('is-leeg');
      wortel.classList.remove('lf-zk-open');
    }

    invoer.addEventListener('focus', function () {
      if (invoer.value.trim().length < MINIMUM) toonLeeg();
      else wortel.classList.add('lf-zk-open');
    });

    /* Zodra er genoeg getypt is, neemt het suggestiescript het paneel over;
       wij halen dan alleen onze eigen opmaak eraf. */
    invoer.addEventListener('input', function () {
      if (invoer.value.trim().length >= MINIMUM) paneel.classList.remove('is-leeg');
      else toonLeeg();
    });

    /* een populaire zoekopdracht aanklikken vult het veld en zoekt meteen */
    paneel.addEventListener('click', function (e) {
      var knop = e.target.closest ? e.target.closest('[data-lf-zk-term]') : null;
      if (!knop) return;
      invoer.value = knop.getAttribute('data-lf-zk-term');
      invoer.dispatchEvent(new Event('input', { bubbles: true }));
      invoer.focus();
    });

    document.addEventListener('click', function (e) {
      var binnen = e.target.closest && (e.target.closest('[data-lf-dh-zoekform]'));
      if (!binnen) { paneel.hidden = true; verberg(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { paneel.hidden = true; verberg(); invoer.blur(); }
    });

    if (waas) waas.addEventListener('click', function () { paneel.hidden = true; verberg(); });
  })();

  /* ---------- 2. mobiel: eigen schermvullend paneel ---------- */

  (function mobiel() {
    if (!overlay) return;

    var invoer = overlay.querySelector('[data-lf-zk-invoer]');
    var body = overlay.querySelector('[data-lf-zk-body]');
    var wis = overlay.querySelector('[data-lf-zk-wis]');
    var terug = overlay.querySelector('[data-lf-zk-terug]');
    var timer = null;
    var laatste = '';   // de zoekterm waarvan we het antwoord nog willen

    var teksten = {
      producten: overlay.getAttribute('data-tekst-producten') || 'Producten',
      collecties: overlay.getAttribute('data-tekst-collecties') || 'Collecties',
      alles: overlay.getAttribute('data-tekst-alles') || 'Alle resultaten voor "__TERM__"',
      niets: overlay.getAttribute('data-tekst-niets') || 'Niets gevonden voor "__TERM__". Probeer eens:',
      aanvraagKop: overlay.getAttribute('data-tekst-aanvraag-kop') || 'Zoek je iets wat we niet hebben?',
      aanvraagTekst: overlay.getAttribute('data-tekst-aanvraag') || 'Op aanvraag — stuur ons wat je zoekt via WhatsApp 06 58993634.',
      aanvraagBericht: overlay.getAttribute('data-tekst-aanvraag-bericht') || 'Hoi LodyFair, ik zoek: __TERM__',
      snel: overlay.getAttribute('data-tekst-snel') || '1–2 werkdagen',
      uit: overlay.getAttribute('data-tekst-uit') || 'Uitverkocht',
      normaal: overlay.getAttribute('data-tekst-normaal') || '7–10 werkdagen'
    };

    function vulLeeg() {
      body.innerHTML = '';
      body.appendChild(legeStaat());
    }

    function open() {
      vulLeeg();
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      wortel.classList.add('lf-zk-vol');
      /* Het toetsenbord opent alleen als het veld al zichtbaar is op het moment
         van focus. De klasse zet visibility meteen om (die loopt niet mee in de
         overgang), dus een reflow afdwingen en dan scherpstellen is genoeg. */
      void overlay.offsetHeight;
      invoer.focus();
    }

    function sluit() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      wortel.classList.remove('lf-zk-vol');
      invoer.value = '';
      if (wis) wis.hidden = true;
    }

    /* De zoekknoppen van Impulse onderscheppen. Beide exemplaren dragen
       .js-search-header — dat van het thema en dat van onze mobiele header. */
    document.addEventListener('click', function (e) {
      var knop = e.target.closest ? e.target.closest('.js-search-header, [data-lf-zk-open]') : null;
      if (!knop) return;
      if (window.innerWidth > 1024) return;   // op desktop doet de zoekbalk het werk
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);

    if (terug) terug.addEventListener('click', sluit);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) sluit();
    });

    if (wis) wis.addEventListener('click', function () {
      invoer.value = '';
      wis.hidden = true;
      vulLeeg();
      invoer.focus();
    });

    invoer.addEventListener('input', function () {
      var term = invoer.value.trim();
      if (wis) wis.hidden = term.length === 0;
      if (timer) clearTimeout(timer);

      if (term.length < MINIMUM) { laatste = ''; vulLeeg(); return; }
      timer = setTimeout(function () {
        laatste = term;
        zoekOp(term, function (producten, collecties) {
          /* Antwoorden komen niet altijd in dezelfde volgorde terug als de
             vragen. Zonder deze controle kan een traag antwoord op een oudere
             zoekterm de resultaten van een nieuwere overschrijven. */
          if (term !== laatste) return;
          tekenResultaten(body, producten, collecties, term, teksten);
        });
      }, WACHT);
    });

    /* Enter opent de gewone zoekpagina met wat er staat. */
    invoer.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var term = invoer.value.trim();
      if (!term) return;
      e.preventDefault();
      window.location.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
    });

    body.addEventListener('click', function (e) {
      var knop = e.target.closest ? e.target.closest('[data-lf-zk-term]') : null;
      if (!knop) return;
      invoer.value = knop.getAttribute('data-lf-zk-term');
      invoer.dispatchEvent(new Event('input', { bubbles: true }));
      invoer.focus();
    });

    window.lfZoek = { open: open, sluit: sluit, _body: function () { return body; } };
  })();
})();
